import * as React from 'react';
import { memo } from 'react';

import { POOL_CLUSTER } from 'defs/pools';

import i18n from 'helper/i18n';
import { compileDynamicRoute } from 'helper/string';

import Filter from 'components/molecules/Filter';
import { FilterItemType } from 'components/molecules/Filter';

import { PoolClusterType, PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

const filterIDs = {
	workout: [POOL_CLUSTER.ALL, POOL_CLUSTER.FAVORITE, POOL_CLUSTER.CUSTOM],
	recipe: [POOL_CLUSTER.ALL, POOL_CLUSTER.FAVORITE],
};

const generateFilterItem = (selectedCluster: PoolClusterType, selectedPool: PoolEnumType): FilterItemType => {
	const clusterUrlPart = i18n(`react.impulsCoach.routes.pool.cluster.${selectedCluster}.href`);
	const selectedPoolUrlPart = i18n(`react.impulsCoach.routes.pool.selectedPool.${selectedPool}.href`);
	const label = i18n(`react.impulsCoach.views.pools.${selectedPool}.tabs.${selectedCluster}`);
	const link = compileDynamicRoute(i18n('react.impulsCoach.routes.pool.cluster.href'), {
		cluster: clusterUrlPart,
		selectedPool: selectedPoolUrlPart,
	});

	return {
		link,
		label,
		id: selectedCluster,
	};
};

type PoolTabNavigationProps = {
	selectedPool: PoolEnumType;
	selectedCluster?: PoolClusterType;
	modifier?: string | string[];
};

const PoolTabNavigation = ({ selectedPool, selectedCluster = POOL_CLUSTER.ALL }: PoolTabNavigationProps) => {
	const selectedFilterIDs = filterIDs[selectedPool] || [];

	return (
		<React.Fragment>
			<Filter
				shouldUseReplace // we do not want to save each tab URL inside the history
				selected={selectedCluster}
				filters={selectedFilterIDs.map((id) => generateFilterItem(id, selectedPool))}
			/>
		</React.Fragment>
	);
};

export default memo(PoolTabNavigation, (prevProps, nextProps) => {
	return prevProps.selectedPool === nextProps.selectedPool && prevProps.selectedCluster === nextProps.selectedCluster;
});
